import React from 'react';
import {
    
    Create,
    SimpleForm,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    required,
    TextInput,
    DateInput,
    SelectInput,
    NumberInput,
    SimpleFormIterator
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'
import SanitizedTextInput from '../../controls/SanitizedTextInput';
import ErrorBoundary from '../../ErrorBoundary';

let branch_code =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).branch_code : ''): '';
const testtype =[
    {
        id: 'ATYA',
        name: 'ATYA'
    },
    {
        id: 'NAT',
        name: 'NAT'
    },
    {
        id: 'SPE',
        name: 'SPE/STS'
    },
    {
        id: 'VMT',
        name: 'VMT'
    },
    
]


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const SampleActions = () => (
    <CardActions style={cardActionStyle}>
        <ListButton  
        label='Sample List' 
        basePath={`/samples?filter=%7B"branch_code"%3A"${branch_code}"%7D&order=DESC&page=1&perPage=25`}
        />
    </CardActions>
);



const SampleToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="/samples"
            submitOnEnter={`/samples?filter=%7B"branch_code"%3A"${branch_code}"%7D&order=DESC&page=1&perPage=25`}
        />
    </Toolbar>
);

const tableStyle = {
    margin: "auto",  
    width:"100%" ,  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "left",
  
};


const editStyles = {
    root: { alignItems: 'flex-start'},
    initial: {  width: '5em' },
    booth: {  width: '2em' },
    time: {  width: '7em' },
    volume: {  width: '3em' },
    comments: {  width: '30em' },
    inlineBlock: {
        display: 'inline-flex',
        margin: '5px',
        padding: '5px',
    },
};

function setType(val){

    var option = (val && val.target && val.target.value)? val.target.value : '';
    if(option === 'NAT'){
        document.getElementById("nat").removeAttribute("style");
        document.getElementById("none-nat").setAttribute("style", "display: none;");
    }else{
        document.getElementById("none-nat").removeAttribute("style");
        document.getElementById("nat").setAttribute("style", "display: none;");
    }
}


const ExtraCreate =({ classes, ...props }) => (
<ErrorBoundary>  
<Create 
    title='Samples create' 
    {...props}  
    actions={<SampleActions />} 
    >
  
   <SimpleForm toolbar={<SampleToolbar />}> 
        <table cellPadding={8} style={tableStyle}>
            <tbody>
                <tr>
                    <td  colSpan={4}>
                        <SanitizedTextInput source='branch_code' label='' defaultValue={((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).branch_code : '' } style={{display: 'none'}}/>
                    </td>
                </tr>
                <tr>
                    <td>Box Number:</td>
                    <td><SanitizedTextInput source='box_num' label='' validate={required()} /></td>
                    <td>Bleed date:</td>
                    <td><DateInput source='bleed_date' label='' locales="en-us"  validate={required()} defaultValue={Date()}/></td>
                    
                </tr>
                <tr>
                    <td>Test Mode:</td>
                    <td colSpan="3"><SelectInput source="test_mode" choices={testtype} onChange={value=> setType(value)} defaultValue={"VMT"}/></td>
                </tr>
                <tr id="none-nat">
                    <td>Control Numbers:</td>
                    <td colSpan='3' >
                        <SanitizedTextInput source="cu_numbers" label='' rowsMax={20} multiline fullWidth   />
                    </td>
                </tr>
                <tr id="nat"  style={{display: 'none'}}>
                    <td>Begining Control Number:</td>
                    <td><SanitizedTextInput source='s_ucn' label='' /></td>
                    <td>Ending Control Number:</td>
                    <td><SanitizedTextInput source='e_ucn' label=''/></td>
                </tr>
                <tr>
                    <td>Total:</td>
                    <td colSpan="3"><NumberInput source="total" label=''/></td>
                </tr>
                <tr>
                    <td>Date shipped:</td>
                    <td><DateInput source='ship_date' label='' locales="en-us"  validate={required()} defaultValue={Date()}/></td>
                    <td>Time Removed from Stroage for Shipment:</td>
                    <td><SanitizedTextInput source='time_removed' label='' validate={required()} /></td>
                </tr>
                <tr>
                    <td>Initials:</td>
                    <td><SanitizedTextInput source='init' label='' validate={required()} /></td>
                    <td>Date:</td>
                    <td><DateInput source='init_date' label='' locales="en-us" defaultValue={Date()} validate={required()}/></td>
                </tr>
            </tbody>
        </table>
   </SimpleForm>
</Create>
</ErrorBoundary>
);

export default  withStyles(editStyles)(ExtraCreate);
